import styled from 'styled-components'
import {media, tokens} from "../../../theme";
import {Box, Typography} from "@mui/material";

export const StyledPage = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;

interface MainContainerProps {
    $row?: boolean;
}

export const StyledCard = styled.div<MainContainerProps>`
    display: flex;
    flex: 1;
    flex-direction: ${({$row}) => $row ? 'row' : 'column'};
    min-height: 0;
    overflow: auto;
    gap: 24px;

    border-radius: ${tokens.radius['4xl']};
    border: 1px solid  ${({theme}) => theme.palette.dividers.subtle};
    background-color: ${({theme}) => theme.palette.background.paper};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
`;

export const StyledContent = styled.div`
    display: flex;
    flex: 1;
    align-items: flex-start;
    justify-content: center;
    padding: 0 32px 28px;
    min-height: 0;
    overflow: auto;
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    padding: 28px 32px;
    flex-shrink: 0;
`;

export const HeaderTitleBox = styled(Box)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 16px;
`;

export const StatisticsBox = styled(Box)`
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    border-radius: ${tokens.radius.lg};
    background-color: ${({theme}) => theme.palette.background.dropzone};
    padding: 24px;
    
    display: flex;
    flex-direction: column;
    gap: 24px;

    width: 100%;
    max-width: 420px;
    height: 100%;
    
    ${media.lg} {
        max-width: 500px;
    }
`;

export const StatisticsHeader = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`;

export const StyledSubtitle = styled(Typography)`
    text-transform: uppercase;
    color: ${({theme}) => theme.palette.text.secondary};
    font-size: ${tokens.fontSize.sm};
    font-weight: ${tokens.fontWeight.medium};
`;

